<template>
  <div>
    <nav-breadcrumb :menu="[{label:'还款'}]"/>

    <el-row>
      <el-col>
        <panel label="">
          <el-form :model="repayForm" :rules="repayFormRules" ref="repayForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="24">
                <el-form-item label="实际还款日期：" prop="rex__repayDate" :rules="{required: true, message: '实际还款日期不能为空'}"  label-width="150px">
                  <el-date-picker
                    v-model="repayForm.rex__repayDate"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="收款账户：" prop="cj__inboundAccountId" :rules="{required: true, message: '收款账户不能为空'}" label-width="150px">
                  <el-select placeholder="请选择收款账户" v-model.trim="repayForm.cj__inboundAccountId" filterable>
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in payAccountList" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item >
                  <el-checkbox label="提前还贷" true-label="Y" false-label="N" v-model.trim="repayForm.rex__advancedRepayment"/>
                  <el-checkbox label="逾期" true-label="Y" false-label="N" v-model.trim="repayForm.rex__overdueRepayment"/>
                </el-form-item>
              </el-col>
            </el-row>
            <form-build
              :form-data="repayForm"
              :form-rules="repayFormRules"
              :form-columns="repayFormColumns"
              class="formTable"
            />
            <div class="totalltxt tr of">
              实收总计： {{repayForm.rex__allAmount|formatMoney}}
            </div>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="还款备注：" label-width="150px">
                  <el-input type="textarea"  v-model.trim="repayForm.rex__remarks"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row>
            <el-col :span="24">
              <el-button type="primary" @click="onSubmit()">确认提交</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-col>
          </el-row>
        </panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {formatMoney} from "../../filters/CommonFilters";
  import xhr from '../../utils/xhr'
    export default {
        name: "RepayFinancing",
        data(){
          return {
            entryId: this.$route.query['entryId'],
            repayForm:{
              'plan__entryId':this.$route.query['entryId'],
              'rex__principalAmount':0,
              'rex__deductionAmount':0,
              'rex__interestAmount':0,
              'rex__exBalanceAmount':0,
              'rex__overdueFine':0,
              'rex__penaltyAmount':0,
              'rex__lendingFeeAmount':0,
              'rex__otherAmount':0,
              'rex__excessAmount':0,
              'rex__allAmount':0,
              'rex__allAmount1':0,
              'rex__allAmount2':0,
              'rex__advancedRepayment':'N',
              'rex__overdueRepayment':'N'
            },
            payAccountList:[],
            repayFormRules:{},
            repayFormRules:{
              rex__principalAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__deductionAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__interestAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__exBalanceAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__overdueFine: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],

              rex__penaltyAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__lendingFeeAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__otherAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              rex__excessAmount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            repayFormColumns:[
              {
                label: '实收本金',
                field: 'rex__principalAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '减免费用',
                field: 'rex__deductionAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '实收利息',
                field: 'rex__interestAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '上期退款',
                field: 'rex__exBalanceAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '实收逾期罚息',
                field: 'rex__overdueFine',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '',
                field: '',
              },
              {
                label: '提前还贷违约金',
                field: 'rex__penaltyAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '',
                field: '',
              },
              {
                label: '服务费',
                field: 'rex__lendingFeeAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '',
                field: '',
              },

              {
                label: '其他费用',
                field: 'rex__otherAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '',
                field: '',
              },
              {
                label: '多收费用',
                field: 'rex__excessAmount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '',
                field: '',
              },
              {
                label: '合计',
                field: 'rex__allAmount1',
                formatter: function (c,v) {
                  return formatMoney(v)
                }
              },
              {
                label: '',
                field: 'rex__allAmount2',
                formatter: function (c,v) {
                  return formatMoney(v)
                }
              },


            ],
          }
        },
      mounted(){
          this.getData()
          this.getBankAccountList()
      },
      watch:{
        'repayForm.cj__inboundAccountId':function () {
          let arr =  this.payAccountList.filter(item=>
            item.value == this.repayForm.cj__inboundAccountId
          )
          this.repayForm.cj__inboundAccountDesc = arr[0].ba__bank+arr[0].ba__accountNo+arr[0].ba__branch
        },
        'repayForm.rex__principalAmount':function () {
            this.amountAdd()
        },
        'repayForm.rex__interestAmount':function () {
          this.amountAdd()
        },
        'repayForm.rex__overdueFine':function () {
          this.amountAdd()
        },
        'repayForm.rex__penaltyAmount':function () {
          this.amountAdd()
        },
        'repayForm.rex__lendingFeeAmount':function () {
          this.amountAdd()
        },
        'repayForm.rex__otherAmount':function () {
          this.amountAdd()
        },
        'repayForm.rex__excessAmount':function () {
          this.amountAdd()
        },

        'repayForm.rex__deductionAmount':function () {
          this.repayForm.rex__allAmount2 = 0-this.repayForm.rex__deductionAmount-this.repayForm.rex__exBalanceAmount

          this.repayForm.rex__allAmount = parseFloat(this.repayForm.rex__allAmount1)+parseFloat(this.repayForm.rex__allAmount2)
        },
        'repayForm.rex__exBalanceAmount':function () {
          this.repayForm.rex__allAmount2 = 0-this.repayForm.rex__deductionAmount-this.repayForm.rex__exBalanceAmount
          this.repayForm.rex__allAmount = parseFloat(this.repayForm.rex__allAmount1)+parseFloat(this.repayForm.rex__allAmount2)
        }
      },
      computed:{

      },
      methods:{
        formatMoney,
          getData:function(){
            xhr.getRepayPlan({
              'plan.entryId': this.entryId
            }, res => {
             let planForm = res.data.data || []

              this.repayForm.rex__principalAmount = planForm.plan__principalAmount
              this.repayForm.rex__interestAmount = planForm.plan__interestAmount
              this.repayForm.rex__lendingFeeAmount = planForm.plan__lendingFeeAmount
              this.repayForm.rex__otherAmount = planForm.plan__otherAmount
              this.repayForm.rex__allAmount2 = 0-this.repayForm.rex__deductionAmount-this.repayForm.rex__exBalanceAmount

              this.repayForm.rex__allAmount = parseFloat(this.repayForm.rex__allAmount1)+parseFloat(this.repayForm.rex__allAmount2)


            })
          },
          amountAdd:function(){
            this.repayForm.rex__allAmount1 = parseFloat(this.repayForm.rex__principalAmount)+  parseFloat(this.repayForm.rex__interestAmount) +  parseFloat(this.repayForm.rex__overdueFine)
              +  parseFloat(this.repayForm.rex__penaltyAmount)
              +  parseFloat(this.repayForm.rex__lendingFeeAmount)
              +  parseFloat(this.repayForm.rex__otherAmount)
              +  parseFloat(this.repayForm.rex__excessAmount)
            this.repayForm.rex__allAmount = parseFloat(this.repayForm.rex__allAmount1)+parseFloat(this.repayForm.rex__allAmount2)
          },
          getBankAccountList: function () {
            xhr.getBankAccountList({},res=>{
              try{
                if(res.data.status == 'success') {
                  this.payAccountList = res.data.data.map(item=>{
                    return {
                      label: item.ba__bank+item.ba__accountNo+item.ba__branch,
                      value:item.ba__accountId,
                      ba__accountNo :item.ba__accountNo,
                      ba__bank :item.ba__bank,
                      ba__branch :item.ba__branch,
                    }
                  })

                }
              }catch (e) {

              }
            })
          },
        onSubmit:function(){
          this.repayForm.rex__checked = true
          this.repayForm.rex__totalAmount = parseFloat(this.repayForm. rex__allAmount).toFixed(4)

          this.repayForm.rex__principalAmount = parseFloat(this.repayForm. rex__principalAmount).toFixed(4)
          this.repayForm.rex__deductionAmount  = parseFloat(this.repayForm. rex__deductionAmount).toFixed(4)
          this.repayForm.rex__interestAmount = parseFloat(this.repayForm. rex__interestAmount).toFixed(4)
          this.repayForm.rex__exBalanceAmount = parseFloat(this.repayForm. rex__exBalanceAmount).toFixed(4)
          this.repayForm.rex__overdueFine = parseFloat(this.repayForm. rex__overdueFine).toFixed(4)
          this.repayForm.rex__penaltyAmount = parseFloat(this.repayForm. rex__penaltyAmount).toFixed(4)
          this.repayForm.rex__lendingFeeAmount = parseFloat(this.repayForm. rex__lendingFeeAmount).toFixed(4)
          this.repayForm.rex__otherAmount = parseFloat(this.repayForm. rex__otherAmount).toFixed(4)
          this.repayForm.rex__excessAmount = parseFloat(this.repayForm. rex__excessAmount).toFixed(4)

          xhr.updateRepayPlan(
            this.repayForm,
            res=> {
              try{
                if(res.data.status == 'success') {

                }else{

                  this.$message.error(res.data.msgs[0].text)
                }
                this.$router.push({
                  name: 'RepayFinancingListView'
                })
              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/RepayFinancing.vue